import { primitive } from 'styles/constants';

export default {
  addressColor: primitive.$greyOne,
  ammenityIconFill: primitive.$greyOne,
  innerAnchorColor: primitive.$greyOne,
  innerColor: primitive.$greyOne,
  innerPColor: primitive.$greyOne,
  innerLineHeight: 'lg',
  modalBackground: primitive.$mayoEggWhite,
  phoneNumberColor: primitive.$greyOne,
};
